import { render, staticRenderFns } from "./home-template.vue?vue&type=template&id=8f9457f6&scoped=true&"
import script from "./home-template.vue?vue&type=script&lang=js&"
export * from "./home-template.vue?vue&type=script&lang=js&"
import style0 from "./home-template.vue?vue&type=style&index=0&id=8f9457f6&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9457f6",
  null
  
)

export default component.exports